import { Component, input } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'lib-duplicate-icon',
  standalone: true,
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      fill="none"
      [style.color]="color()"
      [class]="iconClass()">
      <path
        d="M13.3332 10.5751V15.0668C13.3332 17.0168 12.0332 18.3084 10.0915 18.3084H4.90817C2.9665 18.3084 1.6665 17.0168 1.6665 15.0668V8.59176C1.6665 6.64176 2.9665 5.3501 4.90817 5.3501H8.09984C8.95817 5.3501 9.78317 5.69176 10.3915 6.3001L12.3832 8.28343C12.9915 8.89176 13.3332 9.71676 13.3332 10.5751Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M18.3332 6.87493V11.3666C18.3332 13.3083 17.0332 14.6083 15.0915 14.6083H13.3332V10.5749C13.3332 9.7166 12.9915 8.8916 12.3832 8.28327L10.3915 6.29994C9.78317 5.6916 8.95817 5.34993 8.09984 5.34993H6.6665V4.88327C6.6665 2.9416 7.9665 1.6416 9.90817 1.6416H13.0998C13.9582 1.6416 14.7832 1.98327 15.3915 2.5916L17.3832 4.58327C17.9915 5.1916 18.3332 6.0166 18.3332 6.87493Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>
  `,
})
export class DuplicateIconComponent extends BaseIconComponent {
  override viewBox = input<string>('0 0 20 20');
}
